import { defineComponent as m, useSlots as k, computed as p, openBlock as o, createElementBlock as n, createElementVNode as d, renderSlot as l, Fragment as B, createBlock as s, unref as r, withCtx as c, createTextVNode as u, toDisplayString as g, createCommentVNode as a } from "vue";
import "./ghl-ui.es23.js";
import f from "./ghl-ui.es72.js";
const S = { class: "hl-modal-footer-actions" }, $ = { class: "action-left" }, C = { class: "action-right" };
m({
  name: "UIModalFooter"
});
const T = m({
  __name: "ModalFooter",
  props: {
    id: {
      type: String,
      required: !0
    },
    positiveText: {
      type: String,
      default: ""
    },
    negativeText: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "primary"
    },
    disableNegativeBtn: {
      type: Boolean,
      default: void 0
    }
  },
  setup(e) {
    const v = k(), y = p(() => !!v.actionRight);
    return (t, i) => (o(), n("div", S, [
      d("div", $, [
        l(t.$slots, "actionLeft")
      ]),
      d("div", C, [
        l(t.$slots, "actionRight"),
        y.value ? a("", !0) : (o(), n(B, { key: 0 }, [
          e.negativeText ? (o(), s(r(f), {
            key: 0,
            onClick: i[0] || (i[0] = (b) => t.$emit("negativeClick")),
            id: `${e.id}-btn-negative-action`,
            disabled: e.disableNegativeBtn
          }, {
            default: c(() => [
              u(g(e.negativeText), 1)
            ]),
            _: 1
          }, 8, ["id", "disabled"])) : a("", !0),
          e.positiveText ? (o(), s(r(f), {
            key: 1,
            loading: e.loading,
            disabled: e.disabled,
            type: e.type,
            id: `${e.id}-btn-positive-action`,
            onClick: i[1] || (i[1] = (b) => t.$emit("positiveClick"))
          }, {
            default: c(() => [
              u(g(e.positiveText), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "type", "id"])) : a("", !0)
        ], 64))
      ])
    ]));
  }
}), F = T;
export {
  F as default
};
